// utils/wxAuth.js
import { Toast } from 'vant'

/**
 * 判断是否在微信内置浏览器中
 */
export function isWechatBrowser() {
    const ua = navigator.userAgent.toLowerCase()
    return /micromessenger/.test(ua)
}

/**
 * 封装微信登录跳转
 * @param {string} appid - 微信公众号AppId
 * @param {string} url - 回调地址（当前页面地址）
 */
export const wxLogin = (appid, url) => {
    if (!isWechatBrowser()) {
        Toast.fail('请在微信内打开')
        return false
    }
    let redirectUri = encodeURIComponent(url);
    window.location.href =
        `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirectUri}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`;
};

/**
 * 获取 URL 参数
 */
export function getUrlParam(name) {
    const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)")
    const r = window.location.search.substr(1).match(reg)
    if (r != null) return decodeURIComponent(r[2])
    return null
}